module.exports = __webpack_public_path__ + "static/img/award3.0f4fdc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award3.png
// module id = 3wKo
// module chunks = 7